import React from "react";
import { format, parseISO } from "date-fns";
import { Card, CardBody, CardTitle } from "components/ui/Card";
import { Spinner } from "components/ui/Spinner";
import { LargeSpacer } from "components/ui/VerticalSpacers";
import fetchServiceAlerts from "data/actions/serviceAlertsActions";
import { useSlice } from "components/hooks/useSlice";
import { dispatchSliceWithCSRF } from "../hooks/dispatchSliceWithCSRF";

export function CalCentralUpdateCard() {
  dispatchSliceWithCSRF(fetchServiceAlerts);

  const [serviceAlert, loadState] = useSlice("serviceAlerts", (slice) => {
    const { data = [], loadState } = slice;
    const serviceAlert = data.find((alert) => alert.banner);
    return [serviceAlert, loadState];
  });

  return (
    <>
      <LargeSpacer />
      <Card data-testid="calcentral-update-card">
        <CardTitle>
          <h2>CalCentral Update</h2>
        </CardTitle>
        <CardBody>
          {loadState === "pending" && <Spinner />}
          {loadState === "success" && serviceAlert ? (
            <>
              <h3 style={{ marginTop: `15px` }}>
                {format(
                  parseISO(
                    serviceAlert.publication_date ||
                      serviceAlert.publicationDate
                  ),
                  "MMM dd"
                )}{" "}
                - {serviceAlert.title}
              </h3>
              <div
                dangerouslySetInnerHTML={{ __html: serviceAlert.body }}
              ></div>
            </>
          ) : (
            <div>
              <p>There are no updates at this time.</p>
            </div>
          )}
        </CardBody>
      </Card>
    </>
  );
}
